import { isWebClient } from "../constants";
import { evictOldest } from "../utils/evictOldest";
import { clearStateCache, getLinkingConfig as createLinkingConfig } from "./getLinkingConfig";
var linkingConfig;
var cachedBaseLinkingConfig;
var cachedRouteNodeForLinking = null;
var cachedLinkingConfigKey = "";
var ssrStateCache = /* @__PURE__ */ new Map();
function getResolvedLinking() {
  return linkingConfig;
}
function setLinking(_) {
  linkingConfig = _;
}
function resetLinking() {
  linkingConfig = void 0;
}
function ensureBaseLinkingConfig(routeNode, linking) {
  var linkingConfigKey = getLinkingConfigKey(linking);
  if (routeNode && (routeNode !== cachedRouteNodeForLinking || linkingConfigKey !== cachedLinkingConfigKey || !cachedBaseLinkingConfig)) {
    clearStateCache();
    ssrStateCache.clear();
    cachedBaseLinkingConfig = createLinkingConfig(routeNode, true, linking);
    cachedRouteNodeForLinking = routeNode;
    cachedLinkingConfigKey = linkingConfigKey;
  }
}
function getSSRInitialState(routeNode, initialLocation, linking) {
  var _cachedBaseLinkingConfig_getStateFromPath;
  if (!routeNode) return void 0;
  ensureBaseLinkingConfig(routeNode, linking);
  if (!cachedBaseLinkingConfig) return void 0;
  var path = initialLocation.pathname + (initialLocation.search || "");
  if (ssrStateCache.has(path)) return ssrStateCache.get(path);
  var state = (_cachedBaseLinkingConfig_getStateFromPath = cachedBaseLinkingConfig.getStateFromPath) === null || _cachedBaseLinkingConfig_getStateFromPath === void 0 ? void 0 : _cachedBaseLinkingConfig_getStateFromPath.call(cachedBaseLinkingConfig, path, cachedBaseLinkingConfig.config);
  evictOldest(ssrStateCache, 5e3, 1e3);
  ssrStateCache.set(path, state);
  return state;
}
function setupLinking(routeNode, initialLocation, linking) {
  var initialState;
  if (routeNode) {
    ensureBaseLinkingConfig(routeNode, linking);
    linkingConfig = {
      ...cachedBaseLinkingConfig
    };
    if (initialLocation) {
      var _linkingConfig_getStateFromPath;
      linkingConfig.getInitialURL = function() {
        return initialLocation.toString();
      };
      var path = initialLocation.pathname + (initialLocation.search || "");
      if (isWebClient) {
        var _historyState___tempLocation;
        var historyState = window.history.state;
        if ((historyState === null || historyState === void 0 ? void 0 : (_historyState___tempLocation = historyState.__tempLocation) === null || _historyState___tempLocation === void 0 ? void 0 : _historyState___tempLocation.pathname) && !historyState.__tempKey) {
          path = historyState.__tempLocation.pathname + (historyState.__tempLocation.search || "");
        }
      }
      initialState = (_linkingConfig_getStateFromPath = linkingConfig.getStateFromPath) === null || _linkingConfig_getStateFromPath === void 0 ? void 0 : _linkingConfig_getStateFromPath.call(linkingConfig, path, linkingConfig.config);
    }
  }
  return initialState;
}
var filterIds = /* @__PURE__ */ new WeakMap();
var filterIdCounter = 0;
function getFilterId(filter) {
  if (!filter) return 0;
  var id = filterIds.get(filter);
  if (id === void 0) {
    id = ++filterIdCounter;
    filterIds.set(filter, id);
  }
  return id;
}
function getLinkingConfigKey(linking) {
  var _ref;
  var schemes = Array.isArray(linking === null || linking === void 0 ? void 0 : linking.scheme) ? [
    ...linking.scheme
  ].sort() : (_ref = linking === null || linking === void 0 ? void 0 : linking.scheme) !== null && _ref !== void 0 ? _ref : null;
  var prefixes = (linking === null || linking === void 0 ? void 0 : linking.prefixes) ? [
    ...linking.prefixes
  ].sort() : null;
  return JSON.stringify({
    scheme: schemes,
    prefixes,
    filterId: getFilterId(linking === null || linking === void 0 ? void 0 : linking.filter)
  });
}
export {
  ensureBaseLinkingConfig,
  getResolvedLinking,
  getSSRInitialState,
  resetLinking,
  setLinking,
  setupLinking
};
//# sourceMappingURL=linkingConfig.js.map
